var map = {
	"./imageHowToPlay1.webp": 6642,
	"./imageHowToPlay10.webp": 9889,
	"./imageHowToPlay11.webp": 5395,
	"./imageHowToPlay12.webp": 1140,
	"./imageHowToPlay13 white bg.webp": 8634,
	"./imageHowToPlay13.webp": 4347,
	"./imageHowToPlay14.webp": 7166,
	"./imageHowToPlay15.webp": 147,
	"./imageHowToPlay16.webp": 7948,
	"./imageHowToPlay17.webp": 97,
	"./imageHowToPlay18.webp": 7304,
	"./imageHowToPlay2.webp": 8272,
	"./imageHowToPlay20.webp": 5670,
	"./imageHowToPlay21.webp": 4019,
	"./imageHowToPlay22.webp": 9082,
	"./imageHowToPlay23.webp": 8015,
	"./imageHowToPlay24.webp": 1797,
	"./imageHowToPlay25.webp": 3458,
	"./imageHowToPlay26.webp": 7774,
	"./imageHowToPlay27.webp": 1642,
	"./imageHowToPlay28.webp": 4327,
	"./imageHowToPlay29.webp": 1174,
	"./imageHowToPlay3.webp": 9281,
	"./imageHowToPlay30.webp": 4533,
	"./imageHowToPlay31.webp": 7866,
	"./imageHowToPlay32.webp": 9838,
	"./imageHowToPlay33.webp": 1128,
	"./imageHowToPlay34.webp": 1732,
	"./imageHowToPlay35.webp": 9793,
	"./imageHowToPlay36.webp": 3087,
	"./imageHowToPlay37.webp": 7782,
	"./imageHowToPlay38.webp": 2783,
	"./imageHowToPlay39.webp": 7479,
	"./imageHowToPlay4.webp": 4940,
	"./imageHowToPlay40.webp": 3616,
	"./imageHowToPlay41.webp": 9122,
	"./imageHowToPlay42.webp": 1702,
	"./imageHowToPlay43.webp": 6159,
	"./imageHowToPlay44.webp": 8244,
	"./imageHowToPlay45.webp": 5979,
	"./imageHowToPlay46.webp": 8824,
	"./imageHowToPlay47.webp": 7127,
	"./imageHowToPlay48.webp": 8596,
	"./imageHowToPlay49.webp": 722,
	"./imageHowToPlay5.webp": 7800,
	"./imageHowToPlay50.webp": 8221,
	"./imageHowToPlay51.webp": 6206,
	"./imageHowToPlay52.webp": 3124,
	"./imageHowToPlay53.webp": 5766,
	"./imageHowToPlay54.webp": 7518,
	"./imageHowToPlay55.webp": 1793,
	"./imageHowToPlay56.webp": 2628,
	"./imageHowToPlay57.webp": 4594,
	"./imageHowToPlay58.webp": 6170,
	"./imageHowToPlay59.webp": 3815,
	"./imageHowToPlay6.webp": 5385,
	"./imageHowToPlay60.webp": 1427,
	"./imageHowToPlay61.webp": 3962,
	"./imageHowToPlay62.webp": 5645,
	"./imageHowToPlay63.webp": 4163,
	"./imageHowToPlay64.webp": 3686,
	"./imageHowToPlay65.webp": 9078,
	"./imageHowToPlay66.webp": 4423,
	"./imageHowToPlay67.webp": 114,
	"./imageHowToPlay68.webp": 7195,
	"./imageHowToPlay7.webp": 448,
	"./imageHowToPlay8.webp": 6476,
	"./imageHowToPlay9.webp": 5009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 940;